import { useQuery } from "@apollo/client/react";

import { BillingTierFeature } from "types/generated";
import useTierFeature from "views/Account/hooks/useTierFeature";

import { CHECK_TEMPLATES } from "./gql";

const useTemplatesCheck = () => {
  const isFeatureEnabled = useTierFeature(BillingTierFeature.Blueprints);

  const { loading, data } = useQuery(CHECK_TEMPLATES, {
    fetchPolicy: "no-cache",
    skip: isFeatureEnabled,
  });

  const hasTemplates = loading ? undefined : !!data?.searchTemplates?.edges.length;

  return {
    checking: loading,
    showUpSell: !isFeatureEnabled && hasTemplates === false,
  };
};

export default useTemplatesCheck;
